/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Room_Association_Plan_InstructionsInputs */

const fr_air_handler_unit_room_association_plan_instructions = /** @type {((inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => LocalizedString) & { parts: (inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Sélectionner plusieurs pièces :
 + sélectionner une zone`)
		}),
		{
			parts: /** @type {(inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Sélectionner plusieurs pièces :\n" }, { type: "markup-start", name: "i", options: {}, attributes: {} }, { type: "markup-end", name: "i", options: {}, attributes: {} }, { type: "text", value: " + sélectionner une zone" }])
			})
		}
	)
);

const en_air_handler_unit_room_association_plan_instructions = /** @type {((inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => LocalizedString) & { parts: (inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Select multiple rooms:
 + select an area`)
		}),
		{
			parts: /** @type {(inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Select multiple rooms:\n" }, { type: "markup-start", name: "i", options: {}, attributes: {} }, { type: "markup-end", name: "i", options: {}, attributes: {} }, { type: "text", value: " + select an area" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Select multiple rooms: + select an area" |
*
* @param {Air_Handler_Unit_Room_Association_Plan_InstructionsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_room_association_plan_instructions = /** @type {((inputs?: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Room_Association_Plan_InstructionsInputs, { locale?: "fr" | "en" }, { i: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_air_handler_unit_room_association_plan_instructions(inputs)
			return fr_air_handler_unit_room_association_plan_instructions(inputs)
		}),
		{
			parts: /** @type {(inputs?: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (en_air_handler_unit_room_association_plan_instructions).parts?.(inputs) ?? [{ type: "text", value: en_air_handler_unit_room_association_plan_instructions(inputs) }]
				return /** @type {{ parts?: (inputs: Air_Handler_Unit_Room_Association_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (fr_air_handler_unit_room_association_plan_instructions).parts?.(inputs) ?? [{ type: "text", value: fr_air_handler_unit_room_association_plan_instructions(inputs) }]
			})
		}
	)
);